<template>
    <div class="fullscreen-box">
        <div class="fullscreen-box--outer">
            <div class="fullscreen-box--inner">
                <div class="fullscreen-box--container">
                    <div class="fullscreen-box--content">
                        <div id="box_component" class="box-component">
                            <div class="box-component-inner">
                                <div v-if="userFromUe && !termsAccepted">
                                    <p>Dear user,</p>
                                    <p>We regret to inform You that Your account has been blocked. In
                                        order to regain access
                                        to Your account it is required that You accept two GDPR agreements (first two check
                                        boxes). Lack of acceptance will result in irreversible termination of that account.
                                        We ask that You make sure that Your agreement is saved on all platforms.</p>
                                </div>
                                <form action="" class="register-form"
                                      @submit.prevent="validate">
                                    <div style="margin-bottom: 20px;"
                                         v-for="(term, index) in termsList"
                                         :key="index">
                                        <checkbox :label="'term'"
                                                  :message="term.content"
                                                  :name="term.key"
                                                  :progress="progress"
                                                  :rules="false"
                                                  :show-errors="showErrors"
                                                  :update-value="updateValue"
                                                  :checked="getValue(term.key)"
                                                  :add-class="term.required ? 'required dark' : 'dark'"></checkbox>
                                    </div>
                                    <div class="form-actions">
                                        <button class="button--primary password"
                                                :class="{ 'button--progress': progress }"
                                                :type="progress ? 'button' : 'submit'">Confirm
                                        </button>
                                        <br>or<br>
                                        <router-link :to="{'name': 'Dashboard'}">Cancel</router-link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Checkbox from './fields/Checkbox';

    export default {
        components: {Checkbox},
        dependencies: ['popup', 'terms', 'user'],
        data() {
            return {
                areChanges: false,
                progress: false,
                showErrors: false,
                signatures: []
            }
        },
        computed: {
            termsAccepted () {
                return this.$store.getters.user.terms_of_use_accepted;
            },
            termsList() {
                return this.$store.getters.terms;
            },
            userFromUe() {
                return this.$store.getters.user.isFromUe;
            }
        },
        methods: {
            getValue(name) {
                return this.signatures.filter(function (obj) {
                    if (obj.regulation === name) {
                        return !!obj.accepted;
                    }
                })[0];
            },

            updateValue(name, value) {

                let messages = {
                    'consent-to-data-processing-for-marketing-purposes': 'Withdrawal of consent means no access to marketing information.',
                    'consent-to-sending-commercial-information-by-email': 'Withdrawal of consent means no access to our newsletter.',
                    'declaration-of-familiarization-with-the-information-clause': 'Withdrawal of consent means blocking your accounts and therefore you will lose access to them.',
                    'declaration-of-familiarization-with-the-regulations': 'Withdrawal of consent means blocking your accounts and therefore you will lose access to them.'
                };

                this.signatures.filter(function (obj) {
                    if (obj.regulation === name) {
                        obj.accepted = value ? 1 : 0;
                    }
                });

                this.areChanges = true;

                if (!value) this.popup.show(messages[name]);
            },
            validate() {
                this.$validator.validateAll().then(() => {
                    if (!this.errors.any()) {
                        if (this.areChanges) {
                            this.showErrors = false;
                            this.submit();
                        }
                    } else {
                        this.showErrors = true;
                    }
                });

            },
            submit() {
                this.progress = true;
                this.terms.sign(this.signatures).then(() => {
                    this.progress = false;
                    this.user.reloadData().then(() => {
                        this.$router.push('/');
                        this.popup.show('Thank you for submmiting and thank you for being part of FutureNet.', 'OK', false);
                    });
                });
            }
        },
        created() {
            this.terms.fetchData().then(() => {
                for (let term in this.termsList) {
                    this.signatures.push({
                        regulation: this.termsList[term].key,
                        accepted: 0
                    });
                }
            });
        },
        mounted() {
            this.terms.setAccepted().then(() => {
                let acceptedList = this.$store.getters.acceptedTerms;

                for (let term in acceptedList) {
                    if (acceptedList[term].accepted) {
                        this.updateValue(acceptedList[term].key, true);
                    }
                }
            })
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_colors.scss';
    @import '../../assets/scss/_guest.scss';
    @import '../../assets/css/transitions.css';

    .fullscreen-box {
        background-image: url('../../assets/img/register_background.jpg');
    }

    .fullscreen-box--container {
        padding: 40px 0;
    }

    .register-form {
        margin: 30px 0;
    }

    .box-component-inner {

    p {
        text-align: left;
    }

    }

    .red {
        color: $red !important;
        margin: 0 0 -10px !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/terms/TermsUpdate.vue